import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hudsonConfig } from "./data";

export default function HudsonPage() {
  return <CityPageTemplate config={hudsonConfig} />;
}